import React, { Component, createRef } from "react";
import {
  POST,
  loading,
  tokens,
  locale,
  alert,
  float,
  Modal,
  required,
} from "../components/CustomComponent.js";
import Navbar from "../components/Navbar.js";
import Footer from "../components/Footer.js";
import THUMBNAIL from "../assets/images/thumbnail.png";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";
export default class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_quotation: false,

      slideIndex: 0,

      data_product: [],
      data_demonstration: [],

      photo_index: [],
      message_index: "",
      footer_index: "",

      fax_contact: "",
      phone_contact: "",
      email_contact: "",

      photo_about: "",
      title_about: "",
      message_about: "",

      product: [],
      full_name: "",
      email: "",
      phone: "",
      message: "",

      name_contact_1: "",
      address_contact_1: "",
      phone_contact_1: "",
      fax_contact_1: "",
      email_contact_1: "",
      website_contact_1: "",
    };
  }
  componentDidMount = async () => {
    this.interval = setInterval(() => {
      this.setState((prev) => ({
        slideIndex: (prev.slideIndex + 1) % this.state.photo_index.length,
      }));
    }, 5000);

    loading(false);
    this.Get();
  };
  componentWillUnmount() {
    clearInterval(this.interval);
  }
  Get = async () => {
    loading(true);
    let result = null;
    let response = await fetch(process.env.REACT_APP_API_URL + "/updated.json");
    let update = await response.json();
    if (
      !tokens ||
      (tokens && tokens?.updated?.last_update !== update.last_update)
    ) {
      let response = await fetch(process.env.REACT_APP_API_URL + "/.json");
      result = await response.json();
      localStorage.setItem("scp-acc-tk", JSON.stringify(result));
    } else {
      result = tokens;
    }
    this.setState({
      photo_index: result?.setting?.photo_index,
      message_index:
        result?.setting[`${locale || "th"}_message_index`] ||
        result?.setting?.th_message_index,
      footer_index: result?.setting?.footer_index,

      fax_contact:
        result?.setting[`${locale || "th"}_fax_contact`] ||
        result?.setting?.th_fax_contact,
      phone_contact:
        result?.setting[`${locale || "th"}_phone_contact`] ||
        result?.setting?.th_phone_contact,
      email_contact:
        result?.setting[`${locale || "th"}_email_contact`] ||
        result?.setting?.th_email_contact,

      photo_about: result?.setting?.photo_about,
      title_about:
        result?.setting[`${locale || "th"}_title_about`] ||
        result?.setting?.th_title_about,
      message_about:
        result?.setting[`${locale || "th"}_message_about`] ||
        result?.setting?.th_message_about,

      data_product: (result?.product ? Object.values(result?.product) : [])
        ?.sort(() => Math.random() - 0.5)
        ?.slice(0, 6),
      data_demonstration: result?.demonstration
        ? Object.values(result?.demonstration)
        : [],

      name_contact_1:
        result?.setting[`${locale}_name_contact_1`] ||
        result?.setting?.th_name_contact_1,
      address_contact_1:
        result?.setting[`${locale}_address_contact_1`] ||
        result?.setting?.th_address_contact_1,
      phone_contact_1:
        result?.setting[`${locale}_phone_contact_1`] ||
        result?.setting?.th_phone_contact_1,
      fax_contact_1:
        result?.setting[`${locale}_fax_contact_1`] ||
        result?.setting?.th_fax_contact_1,
      email_contact_1:
        result?.setting[`${locale}_email_contact_1`] ||
        result?.setting?.th_email_contact_1,
      website_contact_1:
        result?.setting[`${locale}_website_contact_1`] ||
        result?.setting?.th_website_contact_1,
    });
    loading(false);
  };
  Submit = async () => {
    const { product, full_name, email, phone, message } = this.state;
    if (!full_name) {
      alert("", "warning", "แจ้งเตือน", "กรุณาชื่อ-นามสกุล");
      return;
    }
    if (!email) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกอีเมล");
      return;
    }
    if (!email.includes("@")) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกรูปแบบอีเมลให้ถูกต้อง");
      return;
    }
    if (!phone) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกเบอร์โทร");
      return;
    }
    if (phone.length < 10) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกเบอร์โทรให้ครบถ้วน");
      return;
    }
    if (!float(phone)) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกเบอร์โทรให้ถูกต้อง");
      return;
    }
    loading(true);

    await fetch(
      process.env.REACT_APP_API_URL + `/contact/${new Date().getTime()}.json`,
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          uid: new Date().getTime(),
          product,
          full_name,
          email,
          phone,
          message,
        }),
      }
    );
    loading(false);
    alert(
      "#",
      "success",
      "สำเร็จ",
      "ขอบคุณที่ติดต่อเรา! เราจะติดต่อกลับโดยเร็วที่สุด"
    );
  };
  render() {
    const {
      modal_quotation,
      slideIndex,
      photo_index,
      fax_contact,
      phone_contact,
      email_contact,
      photo_about,
      title_about,
      message_about,
      message_index,
      footer_index,
      data_product,
      data_demonstration,
      full_name,
      email,
      phone,
      message,
      name_contact_1,
address_contact_1,
phone_contact_1,
fax_contact_1,
email_contact_1,
website_contact_1
    } = this.state;
    return (
      <div className="w-100 min-vh-100 bg-light position-relative">
        <Navbar />
        {/* SECTION 1 HERO */}
        <div
          className="w-100 text-white position-relative overflow-hidden"
          style={{ minHeight: 600 }}
        >
          {/* Slides */}
          {photo_index?.map((img, index) => (
            <div
              key={index}
              className="hero-slide"
              style={{
                backgroundImage: `url(${
                  img || require("../assets/images/thumbnail.png")
                })`,
                opacity: slideIndex === index ? 1 : 0,
              }}
            />
          ))}

          {/* Gradient + Content */}
          <div
            className="position-relative align-content-center"
            style={{
              minHeight: 600,
              background:
                "linear-gradient(to right, rgba(0,0,0,0.8), rgba(0,0,0,0.2), rgba(0,0,0,0))",
            }}
          >
            <div className="row container mx-auto">
              <div className="col-12 col-md-8 col-xl-6 p-0">
                <div className="px-4 mx-auto">
                  <h1 className="fw-bold mb-2">
                    บริษัท เอเชีย อีโค เอิร์ท จำกัด
                  </h1>
                  <h1 className="fw-bold mb-3">ASIA ECO EARTH CO.,LTD.</h1>
                  <h5 className="mb-3">{message_index}</h5>

                  <button
                    className="btn btn-light px-4"
                    onClick={() =>
                      this.setState({
                        modal_quotation: true,
                        full_name: "",
                        email: "",
                        phone: "",
                        message: "",
                      })
                    }
                  >
                    ขอใบเสนอราคา
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* SECTION 2 */}
        <div className="w-100 bg-secondary-light">
          <div className="container mx-auto p-5 text-center">
            <div className="row">
              {fax_contact && (
                <div className="col-12 col-md-8 col-lg-4 mb-3 mx-auto">
                  <div className="p-3" style={{ minHeight: 212 }}>
                    <span className="icon text-60 text-primary">
                      {"\uf1ac"}
                    </span>
                    <h5 className="fw-bold mb-3">โทรสาร</h5>
                    <span className="text-secondary">{fax_contact}</span>
                  </div>
                </div>
              )}
              {phone_contact && (
                <div className="col-12 col-md-8 col-lg-4 mb-3 mx-auto">
                  <div className="p-3" style={{ minHeight: 212 }}>
                    <span className="icon text-60 text-primary">
                      {"\uf095"}
                    </span>
                    <h5 className="fw-bold mb-3">สำนักงานใหญ่</h5>
                    <span className="text-secondary">{phone_contact.split(",").map((phone, index) => <a href={`tel:${phone}`} key={index} style={{color: "inherit", textDecoration: "none"}}>{phone}{index !== phone_contact.split(",").length - 1 ? ", " : ""}</a>)}</span>
                  </div>
                </div>
              )}
              {email_contact && (
                <div className="col-12 col-md-8 col-lg-4 mb-3 mx-auto">
                  <div className="p-3" style={{ minHeight: 212 }}>
                    <span className="icon text-60 text-primary">
                      {"\uf0e0"}
                    </span>
                    <h5 className="fw-bold mb-3">อีเมล</h5>
                    <span className="text-secondary"><a href={`mailto:${email_contact}`} style={{color: "inherit", textDecoration: "none"}}>{email_contact}</a></span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        {/* SECTION 3 */}
        <div className="w-100 bg-light">
            <div className="row">
              <div className="col-12 col-md-6 col-lg-6">
                <div
                  className="d-none d-md-block position-relative align-content-center"
                  style={{
                    minHeight: 600,
                    backgroundImage: `
          linear-gradient(to left,
            rgba(248,249,250,1),
            rgba(248,249,250,0.2),
            rgba(248,249,250,0),
            rgba(248,249,250,0)
          ),
          url(${photo_about || THUMBNAIL})
        `,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                  }}
                />
                <div
                  className="d-block d-md-none position-relative align-content-center"
                  style={{
                    minHeight: 600,
                    backgroundImage: `
                      linear-gradient(to bottom,
                        rgba(248,249,250,1),
                        rgba(248,249,250,0.2),
                        rgba(248,249,250,0),
                        rgba(248,249,250,0),
                        rgba(248,249,250,0.2),
                        rgba(248,249,250,1)
                      ),
                      url(${photo_about || THUMBNAIL})
                    `,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                  }}
                />
              </div>

              <div className="col-12 col-md-6 col-lg-6 text-start px-5">
                <div className="my-5 py-4">
                  <div className="d-flex justify-content-start align-items-center mb-4">
                    <div
                      className="wpx-50 bg-danger"
                      style={{ height: 2 }}
                    ></div>
                    <h6 className="text-danger mb-0 mx-3">เกี่ยวกับบริษัท</h6>
                    <div
                      className="wpx-50 bg-danger"
                      style={{ height: 2 }}
                    ></div>
                  </div>

                  <h2 className="fw-bold mb-4">{title_about}</h2>
                  <div className="text-secondary">{message_about}</div>
                  <a className="btn btn-dark px-4 mt-4" href="/about">
                    อ่านเพิ่มเติม
                  </a>
                </div>
              </div>
            </div>
        </div>
        {/* SECTION 4 */}
        <div className="w-100 bg-secondary-light align-content-center">
          <div className="container px-4 my-5 text-center">
            <div className="d-flex justify-content-center align-items-center mb-4">
              <div className="wpx-50 bg-danger" style={{ height: 2 }}></div>
              <h2 className="fw-bold mb-0 mx-3">สินค้า</h2>
              <div className="wpx-50 bg-danger" style={{ height: 2 }}></div>
            </div>
            <div className="text-secondary">
              สินค้าทั้งหมดจาก บริษัท เอเชีย อีโค เอิร์ท จำกัด
            </div>
          </div>
          <div className="row container mx-auto mt-5 mb-2 justify-content-center">
            {data_product.map((item, index) => (
              <div
                className={
                  "col-12 col-sm-6 col-lg-4 col-xl-3 mb-3 p-1 product pointer" +
                  (index > 3 ? " d-none d-lg-block d-xl-none" : "")
                }
                onClick={() => {
                  window.location.href = "/detail-product?id=" + item.uid;
                }}
              >
                <div className="w-100 hpx-400 bg-light d-flex align-items-center justify-content-center position-relative rounded-3 overflow-hidden mb-3 shadow-sm">
                  {item.photo[0] ? (
                    <img
                      alt="LOGO"
                      src={item.photo[0]}
                      className="h-100 w-100 mx-auto my-5"
                      style={{ objectFit: "cover" }}
                    />
                  ) : (
                    <img
                      alt="LOGO"
                      src={THUMBNAIL}
                      className="h-100 w-75 mx-auto my-5"
                      style={{ objectFit: "contain" }}
                    />
                  )}
                </div>

                <h6
                  className="fw-bold w-100 overflow-hidden mb-2 text-nowrap"
                  style={{ textOverflow: "ellipsis" }}
                >
                  {item[`${locale}_product_name`] || item.th_product_name || ""}
                </h6>
                <small
                  className="text-secondary"
                  style={{
                    display: "-webkit-box",
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                  }}
                >
                  {item[`${locale}_description`] || item.th_description || ""}
                </small>
                <button className="btn btn-primary px-4 mt-3">
                  รายละเอียด
                </button>
              </div>
            ))}
          </div>
          <div className="d-flex justify-content-center w-100 mt-3 mb-5">
            <button
              className="btn btn-primary px-4"
              onClick={() => {
                window.location.href = "/product";
              }}
            >
              ดูสินค้าเพิ่มเติม
            </button>
          </div>
        </div>
        {/* SECTION 5 */}
        <div className="w-100 bg-light align-content-center">
          <div className="container px-4 my-5 text-center">
            <div className="d-flex justify-content-center align-items-center mb-4">
              <div className="wpx-50 bg-danger" style={{ height: 2 }}></div>
              <h2 className="fw-bold mb-0 mx-3">สาธิตสินค้า</h2>
              <div className="wpx-50 bg-danger" style={{ height: 2 }}></div>
            </div>
          </div>
          <div className="container">
            <div className="d-flex overflow-scroll px-4 pb-5">
              {data_demonstration?.map((item, index) => (
                <div className={"col-12 col-sm-6 mb-3 p-1"}>
                  <div className="rounded-3 overflow-hidden hpx-350">
                    <iframe
                      width="100%"
                      height="350"
                      src={`https://www.youtube.com/embed/${
                        item.link?.split("?v=")[1]?.split("&")[0]
                      }`}
                      title="YouTube video player"
                      frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerpolicy="strict-origin-when-cross-origin"
                      allowfullscreen
                    ></iframe>
                  </div>
                  <h5 className="mt-2">
                    {item[`${locale}_message`] || item.th_message || ""}
                  </h5>
                </div>
              ))}
            </div>
          </div>
        </div>
        {/* SECTION 6 */}
        <div
          className="w-100 position-relative"
        >
          <div className="container">
          <div className="row mx-0">
            <div className="col-12 col-md-6 mb-3">
               <div className="my-5">
                <h3 className="fw-bold mb-2">{name_contact_1}</h3>
                <div className="mb-4 text-secondary">
                  เรานำเสนอเตาเผาขยะคุณภาพสูง
                  มุ่งเน้นการผลิตเตาเผาขยะที่ไม่ก่อมลพิษ “จริงใจ ห่วงใย
                  สิ่งแวดล้อม”
                </div>
                {address_contact_1 && (
                  <div className="d-flex align-items-center mb-3">
                    <div className="border-2 border-primary wpx-50 hpx-50 bg-primary-light rounded-3 d-flex align-items-center justify-content-center me-3">
                      <h5 className="icon fw-bold text-22">{"\uf015"}</h5>
                    </div>
                    <div>
                      <b>{name_contact_1}</b><br/>
                      <span>{address_contact_1}</span>
                    </div>
                  </div>
                )}
                {phone_contact_1 && (
                  <div className="d-flex align-items-center mb-3">
                    <div className="border-2 border-primary wpx-50 hpx-50 bg-primary-light rounded-3 d-flex align-items-center justify-content-center me-3">
                      <h5 className="icon fw-bold text-22">{"\uf095"}</h5>
                    </div>
                    <div>
                      <b>โทรได้ที่</b><br/>
                      <span>{phone_contact_1.split(",").map((phone, index) => <a href={`tel:${phone}`} key={index} style={{color: "inherit", textDecoration: "none"}}>{phone}{index !== phone_contact_1.split(",").length - 1 ? ", " : ""}</a>)}</span>
                    </div>
                  </div>
                )}
                {fax_contact_1 && (
                  <div className="d-flex align-items-center mb-3">
                    <div className="border-2 border-primary wpx-50 hpx-50 bg-primary-light rounded-3 d-flex align-items-center justify-content-center me-3">
                      <h5 className="icon fw-bold text-22">{"\uf1ac"}</h5>
                    </div>
                    <div>
                      <b>โทรสาร</b><br/>
                      <span>{fax_contact_1}</span>
                    </div>
                  </div>
                )}
                {email_contact_1 && (
                  <div className="d-flex align-items-center mb-3">
                    <div className="border-2 border-primary wpx-50 hpx-50 bg-primary-light rounded-3 d-flex align-items-center justify-content-center me-3">
                      <h5 className="icon fw-bold text-22">{"\uf0e0"}</h5>
                    </div>
                    <div>
                      <b>อีเมล</b><br/>
                      <span><a href={`mailto:${email_contact_1}`} style={{color: "inherit", textDecoration: "none"}}>{email_contact_1}</a></span>
                    </div>
                  </div>
                )}
                {website_contact_1 && (
                  <div className="d-flex align-items-center mb-3">
                    <div className="border-2 border-primary wpx-50 hpx-50 bg-primary-light rounded-3 d-flex align-items-center justify-content-center me-3">
                      <h5 className="icon fw-bold text-22">{"\uf0ac"}</h5>
                    </div>
                    <div>
                      <b>เว็บไซต์</b><br/>
                      <span><a href={website_contact_1} style={{color: "inherit", textDecoration: "none"}}>{website_contact_1}</a></span>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="col-12 col-md-6 py-5" id="input-message">
              <div className="card card-dashboard rounded-3 bg-secondary-light p-4 shadow-sm border-0">
                {/* <div className="d-flex justify-content-center align-items-center mb-4">
                  <div className="wpx-50 bg-danger" style={{ height: 2 }}></div>
                  <h6 className="text-danger mb-0 mx-3">ติดต่อเรา</h6>
                  <div className="wpx-50 bg-danger" style={{ height: 2 }}></div>
                </div> */}
                <div className="row">
                  <div className="col-12">
                    <div className="mb-2">ชื่อ - นามสกุล</div>
                    <input
                      className="form-control mb-3"
                      type="text"
                      placeholder="ชื่อ - นามสกุล"
                      onChange={(e) => {
                        this.setState({ full_name: e.target.value });
                      }}
                      value={full_name}
                    />
                  </div>
                  <div className="col-12">
                    <div className="mb-2">อีเมล</div>
                    <input
                      className="form-control mb-3"
                      type="email"
                      placeholder="อีเมล"
                      onChange={(e) => {
                        this.setState({ email: e.target.value });
                      }}
                      value={email}
                    />
                  </div>
                  <div className="col-12">
                    <div className="mb-2">เบอร์โทรศัพท์</div>
                    <input
                      className="form-control mb-3"
                      type="text"
                      placeholder="เบอร์โทรศัพท์"
                      maxLength={10}
                      onChange={(e) => {
                        if (!float(e.target.value)) {
                          return;
                        }
                        this.setState({ phone: e.target.value });
                      }}
                      value={phone}
                    />
                  </div>
                  <div className="col-12">
                    <div className="mb-2">ข้อความที่ต้องการติดต่อ</div>
                    <textarea
                      className="form-control mb-3"
                      rows={8}
                      placeholder="ข้อความที่ต้องการติดต่อ"
                      onChange={(e) => {
                        this.setState({ message: e.target.value });
                      }}
                      value={message}
                    />
                  </div>
                  <div className="col-12">
                    <button
                      className="btn btn-primary px-5 w-100"
                      onClick={async () => {
                        this.Submit();
                      }}
                    >
                      ส่งข้อความ
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>
        </div>

        <div className="hpx-30"></div>
        <Footer />
        <Modal
          show={modal_quotation}
          onHide={() => this.setState({ modal_quotation: false })}
        >
          <Modal.Header className="border-0" closeButton>
            <div>
              <h4 className="fw-bold mb-0">ขอใบเสนอราคา</h4>
              <small>ต้องกรอกฟิลด์ที่มีเครื่องหมาย {required}</small>
            </div>
          </Modal.Header>
          <Modal.Body className="pb-0">
            <div className="row">
              <div className="col-12 mb-2">
                <div className="mb-2">
                  เลือกรุ่นที่ต้องการใบเสนอราคา {required}
                </div>
                {data_product.map((item, index) => (
                  <div key={index}>
                    <input
                      type="checkbox"
                      name="product"
                      value={item.th_product_name}
                      checked={this.state.product.includes(item.product_name)}
                      onChange={(e) => {
                        const { product } = this.state;
                        if (e.target.checked) {
                          this.setState({
                            product: [...product, item.product_name],
                          });
                        } else {
                          this.setState({
                            product: product.filter(
                              (p) => p !== item.product_name
                            ),
                          });
                        }
                      }}
                    />{" "}
                    {item[`${locale}_product_name`] || item.th_product_name}
                  </div>
                ))}
              </div>
              <div className="col-12 mb-2">
                <div className="mb-2">ชื่อ - นามสกุล {required}</div>
                <input
                  className="form-control mb-3"
                  type="text"
                  placeholder="ชื่อ - นามสกุล"
                  onChange={(e) => {
                    this.setState({ full_name: e.target.value });
                  }}
                  value={full_name}
                />
              </div>
              <div className="col-12 mb-2">
                <div className="mb-2">อีเมล {required}</div>
                <input
                  className="form-control mb-3"
                  type="email"
                  placeholder="อีเมล"
                  onChange={(e) => {
                    this.setState({ email: e.target.value });
                  }}
                  value={email}
                />
              </div>
              <div className="col-12 mb-2">
                <div className="mb-2">เบอร์โทรศัพท์</div>
                <input
                  className="form-control mb-3"
                  type="text"
                  placeholder="เบอร์โทรศัพท์"
                  maxLength={10}
                  onChange={(e) => {
                    if (!float(e.target.value)) {
                      return;
                    }
                    this.setState({ phone: e.target.value });
                  }}
                  value={phone}
                />
              </div>
              <div className="col-12 mb-2">
                <div className="mb-2">คำถามหรือความคิดเห็น</div>
                <textarea
                  className="form-control mb-3"
                  rows={8}
                  placeholder="คำถามหรือความคิดเห็น"
                  onChange={(e) => {
                    this.setState({ message: e.target.value });
                  }}
                  value={message}
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="pt-0 border-0 d-flex justify-content-end">
            <button
              className="btn btn-danger px-5 w-100"
              onClick={async () => {
                this.Submit();
              }}
            >
              ขอใบเสนอราคา
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
